import { z } from 'zod';

/** How long a new share link works; null = until revoked. */
export const SHARE_EXPIRY_DAYS = [7, 30, null] as const;

export const shareCreateSchema = z.object({
  expiresInDays: z.union([z.literal(7), z.literal(30), z.null()]).default(30),
});
export type ShareCreate = z.input<typeof shareCreateSchema>;

export const shareLinkSchema = z.object({
  id: z.uuid(),
  recipeId: z.uuid(),
  createdAt: z.iso.datetime(),
  expiresAt: z.iso.datetime().nullable(),
  viewCount: z.number().int(),
});
export type ShareLink = z.infer<typeof shareLinkSchema>;

/** A new link: the URL holds the token and is shown once. */
export const shareCreatedSchema = shareLinkSchema.extend({ url: z.url() });
export type ShareCreated = z.infer<typeof shareCreatedSchema>;

export const shareListSchema = z.object({ links: z.array(shareLinkSchema) });
